import React, { useState } from 'react';
import image4 from "../../Assets/Img/image4.png"
import image5 from "../../Assets/Img/image5.png"
import image3 from "../../Assets/Img/image3.png"
import { Link, Route, Routes } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import DenseTable from '../Statika/statika';
import Statika from '../Statika/statika';
import "./Desktop.scss"
const Desktop = () => {
  const jami = [
    {
      id:1,
      materialName: "Yuz Mumtoz Faylasuf",
      author: "Saida Jo'rayeva",
      file: "pdf",
      photo: "https://kitobxon.com/img_knigi/4205.jpg",
      file_name: "/kitoblar/100_mumtoz_faylasuf.pdf",
      file_name: "/kitoblar/100_mumtoz_faylasuf.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:2,
      materialName: "o'tkan kunlar 1-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/kitoblar/01_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:3,
      materialName: "O'tkan kunlar 2-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/kitoblar/02_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:4,
      materialName: "O'tkan kunlar 4-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/kitoblar/04_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:5,
      materialName: "60 yoshda san'atning nurli yo'li",
      author: "Farg'ona kolleki",
      file: "mp3",
      photo: "/image/nurli_yul.jpg",
      file_name: "/kitoblar/60_yoshda_sanatning_nurli_yoli.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:6,
      materialName: "Abay she'rlar va poemalari",
      author: "Abay",
      file: "pdf",
      photo: "../image/abay.jpg",
      file_name: "/kitoblar/abay_sherlar_va_poemalar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:7,
      materialName: "Yana Bahor hokim",
      author: "Zulfiya",
      file: "mp3",
      photo: "",
      file_name: "../kitoblar/zulfiya_yana_bahor_hokim.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:8,
      materialName: "Yillar Sadosi",
      author: "Zulfiya",
      file: "pdf",
      photo: "../image/",
      file_name: "../kitoblar/zulfiya_yillar_sadosi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:9,
      materialName: "Torga Tashrif",
      author: "Zulfiya",
      file: "mp3",
      photo: "../image/",
      file_name: "../kitoblar/zulfiya_torga_tashrif.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:10,
      materialName: "Tong",
      author: "Zulfiya",
      file: "mp3",
      photo: "../image/",
      file_name: "/kitoblar/zulfiya_tong.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:11,
      materialName: "Suq",
      author: "Zufiya",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/zulfiya_suq.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:12,
      materialName: "mirkarim_osim_zhajxun_ustida_bulutlar",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/mirkarim_osim_zhajxun_ustida_bulutlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:13,
      materialName: "mirmuhsin_xozhand_qalsi",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/mirmuhsin_xozhand_qalsi_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:14,
      materialName: "mixail_lermantov_zamonamiz_qahramoni_",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/mixail_lermantov_zamonamiz_qahramoni_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:15,
      materialName: "muxammad_ali_sarbadorlar",
      author: "2-kurs talabasi",
      file: "pdf",
      photo: "",
      file_name: "/kitoblar/muxammad_ali_sarbadorlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:16,
      materialName: "muxammad_ali_sarbadorlar",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/muxammad_ali_sarbadorlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:17,
      materialName: "odil_yoqubov_ulugbek_hazinasi.",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/odil_yoqubov_ulugbek_hazinasi..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:18,
      materialName: "onta_negr_bolasi.",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/onta_negr_bolasi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:19,
      materialName: "orzularingiz_ogirlanishiga_jol_qojmang",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/orzularingiz_ogirlanishiga_jol_qojmang..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:20,
      materialName: "otkir_hoshimov_tushda_kechgan_umirlar",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/otkir_hoshimov_tushda_kechgan_umirlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:21,
      materialName: "pirimqul_qodirov_humoyun_va_akbar",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/pirimqul_qodirov_humoyun_va_akbar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:22,
      materialName: "pirimqul_qodirov_humoyun_va_akbar",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/pirimqul_qodirov_humoyun_va_akbar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:23,
      materialName: "qaldirgochlar_qoshigi",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/qaldirgochlar_qoshigi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:24,
      materialName: "qonun_ustuvorligi_va_inson_manfaatlarini_taminlash",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/qonun_ustuvorligi_va_inson_manfaatlarini_taminlash__yurt_taraqqiyoti_va_xalq_farovonligining_garovi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:25,
      materialName: "sariq_devni_minib",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/sariq_devni_minib.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:26,
      materialName: "shajtanat",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/shajtanat.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:27,
      materialName: "shovqin_erkin_azam_",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/shovqin_erkin_azam_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:28,
      materialName: "tanqidiy_tahlil_qatiy_tartib-intizom_va_shaxsiy_javobgarlik",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/tanqidiy_tahlil_qatiy_tartib-intizom_va_shaxsiy_javobgarlik__har_bir_rahbar_faoliyatining_kundalik_qoidasi_bolishi_kerak.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:29,
      materialName: "usmon_azim._sajlanma_",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/usmon_azim._sajlanma_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:30,
      materialName: "xurshid_davron_bibixoni_qissasi.",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/xurshid_davron_bibixoni_qissasi..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:31,
      materialName: "xurshid_davron_bibixoni_qissasi.",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/xurshid_davron_bibixoni_qissasi..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:32,
      materialName: "yodgor",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/yodgor.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:33,
      materialName: "yulduzli_tunlar",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/yulduzli_tunlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:34,
      materialName: "zaxarli_hayot_yohud_ishq__qurbonlari.",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/zaxarli_hayot_yohud_ishq__qurbonlari..pdf",
      roll: ['student'],
      categories: ['student']
      // dss
    },
    {
      id:35,
      materialName: "zhek_london_martin_iden",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/zhek_london_martin_iden.pdf",
      roll: ['student'],
      categories: ['student']
    },
  ]
  const arxiv = [
    {
      id: 1,
      materialName: "Yuz Mumtoz Faylasuf",
      author: "Saida Jo'rayeva",
      file: "pdf",
      photo: "https://kitobxon.com/img_knigi/4205.jpg",
      file_name: "/100_mumtoz_faylasuf.pdf",
      roll: ['student'],
      categories: ['student']
    },

    {
      id: 2,
      materialName: "Abay she'rlar va poemalari",
      author: "Abay",
      file: "pdf",
      photo: "../image/abay.jpg",
      file_name: "/abay_sherlar_va_poemalar.pdf",
      roll: ['student'],
      categories: ['student']
    },

    {
      id: 3,
      materialName: "Yillar Sadosi",
      author: "Zulfiya",
      file: "pdf",
      photo: "../image/",
      file_name: "/zulfiya_yillar_sadosi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id: 4,
      materialName: "Suq",
      author: "Zufiya",
      file: "pdf",
      photo: "../image/",
      file_name: "/zulfiya_suq.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id: 5,
      materialName: "abdurauf_fitrat._abulfayzxon.pdf",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/abdurauf_fitrat._abulfayzxon.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 6,
      materialName: "aleksandr_pushkin._kapitan_qizi_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/aleksandr_pushkin._kapitan_qizi_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 7,
      materialName: "alvido_qurol_ernest_xemenguej",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/alvido_qurol_ernest_xemenguej.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 8,
      materialName: "asqad_muxtor_chinor_romani",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/asqad_muxtor_chinor_romani_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 9,
      materialName: "axmad_azam_hali_hayot_bor_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/axmad_azam_hali_hayot_bor_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 10,
      materialName: "ayyor_quyoncha_haqida_ertak",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/ayyor_quyoncha_haqida_ertak.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 11,
      materialName: "besh_bolali_yigitcha",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/besh_bolali_yigitcha.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 12,
      materialName: "burgutlar",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/burgutlar.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 13,
      materialName: "erkin_azam_suv_yoqalab",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/erkin_azam_suv_yoqalab.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 24,
      materialName: "erkin_va_farovon_demokratik_ozbekiston_davlatini_birgalikda_barpo_etamiz",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/erkin_va_farovon_demokratik_ozbekiston_davlatini_birgalikda_barpo_etamiz.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 15,
      materialName: "erkin_voxidov_soz_latofati_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/erkin_voxidov_soz_latofati_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 16,
      materialName: "gabriel_garsia_markes_yolgizlikning_yuz_jili_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/gabriel_garsia_markes_yolgizlikning_yuz_jili_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 17,
      materialName: "iqrornoma_lev_tolstoj",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/iqrornoma_lev_tolstoj.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 18,
      materialName: "kapitan_qizi_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/kapitan_qizi_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 19,
      materialName: "karvon_yollari",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/karvon_yollari.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 20,
      materialName: "kuntugmish",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/kuntugmish.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 21,
      materialName: "layli_va_majnun",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/layli_va_majnun.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 22,
      materialName: "mantiqut-tayr._farididdin_attor_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/mantiqut-tayr._farididdin_attor_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 23,
      materialName: "marsel_brion._men_kim_sohibqiron_jahongir_temur.",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/marsel_brion._men_kim_sohibqiron_jahongir_temur..pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 24,
      materialName: "mehrobdan_chayon",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/mehrobdan_chayon.pdf",
      roll: ['public'],
      categories: ['student']
    },
  ]
  const app = [
    {
      id: 1,
      materialName: "easyQuizzy",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/easyQuizzy-2.0-installer.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 2,
      materialName: "InstallPack_Telegram_250b3",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/InstallPack_Telegram_250b3.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 3,
      materialName: "Lotin-Kirill",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Lotin-Kirill.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 4,
      materialName: "MPCHC.exe",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/MPCHC",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 5,
      materialName: "pdf-cracker-setup",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/pdf-cracker-setup.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 6,
      materialName: "Photoshop",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Photoshop.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 7,
      materialName: "PotPlayer",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/PotPlayer.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 8,
      materialName: "Rufus 2.6",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Rufus2.6.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 9,
      materialName: "Total Commander Power Pack8.0.1x86",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/TotalCommanderPowerPack8.0.1x86.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 10,
      materialName: "UltraISO",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/UltraISO.exe",
      roll: ['student'],
      categories: ['public']
    },
  ]
  const [baza, setBaza] = useState(jami)
  const [elektron, setEltron] = useState(arxiv)
  const [pragramma, setPragramma] = useState(app)
  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },

    // {
    //   field: 'age',
    //   headerName: 'Age',  
    //   type: 'number',
    //   width: 90,
    // },
    {
      field: 'fullName',
      headerName: 'Name',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 550,
      valueGetter: (params) =>
        `${params.row.materialName || ''} ${params.row.materialName || ''}`,
    },
    { field: 'file', headerName: 'fayili', width: 140 },
    { field: 'author', headerName: 'Muallifi', width: 200 },
  ];
  const [soniw,setSoniw]=useState(JSON.parse(window.localStorage.getItem("soni"))|| false)
  const rows = [
    {
      id: 1,
      materialName: "Yuz Mumtoz Faylasuf",
      author: "Saida Jo'rayeva",
      file: "pdf",
      photo: "https://kitobxon.com/img_knigi/4205.jpg",
      file_name: "/100_mumtoz_faylasuf.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id: 2,
      materialName: "o'tkan kunlar 1-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/01_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id: 3,
      materialName: "O'tkan kunlar 2-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/02_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id: 4,
      materialName: "O'tkan kunlar 4-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/04_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id: 5,
      materialName: "60 yoshda san'atning nurli yo'li",
      author: "Farg'ona kolleki",
      file: "mp3",
      photo: "/image/nurli_yul.jpg",
      file_name: "/60_yoshda_sanatning_nurli_yoli.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id: 6,
      materialName: "Abay she'rlar va poemalari",
      author: "Abay",
      file: "pdf",
      photo: "../image/abay.jpg",
      file_name: "/abay_sherlar_va_poemalar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id: 7,
      materialName: "Yana Bahor hokim",
      author: "Zulfiya",
      file: "mp3",
      photo: "",
      file_name: "/zulfiya_yana_bahor_hokim.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id: 8,
      materialName: "Yillar Sadosi",
      author: "Zulfiya",
      file: "pdf",
      photo: "../image/",
      file_name: "/zulfiya_yillar_sadosi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id: 9,
      materialName: "Torga Tashrif",
      author: "Zulfiya",
      file: "mp3",
      photo: "../image/",
      file_name: "/zulfiya_torga_tashrif.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id: 10,
      materialName: "Tong",
      author: "Zulfiya",
      file: "mp3",
      photo: "../image/",
      file_name: "/zulfiya_tong.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id: 11,
      materialName: "Suq",
      author: "Zufiya",
      file: "pdf",
      photo: "../image/",
      file_name: "/zulfiya_suq.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id: 12,
      materialName: "easyQuizzy",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/easyQuizzy-2.0-installer.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 13,
      materialName: "InstallPack_Telegram_250b3",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/InstallPack_Telegram_250b3.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 14,
      materialName: "Lotin-Kirill",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Lotin-Kirill.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 15,
      materialName: "MPCHC.exe",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/MPCHC",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 16,
      materialName: "pdf-cracker-setup",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/pdf-cracker-setup.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 17,
      materialName: "Photoshop",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Photoshop.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 18,
      materialName: "PotPlayer",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/PotPlayer.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 19,
      materialName: "Rufus 2.6",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Rufus2.6.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 20,
      materialName: "Total Commander Power Pack8.0.1x86",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/TotalCommanderPowerPack8.0.1x86.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 21,
      materialName: "UltraISO",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/UltraISO.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 22,
      materialName: "abdurauf_fitrat._abulfayzxon",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/abdurauf_fitrat._abulfayzxon.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 23,
      materialName: "aleksandr_pushkin._kapitan_qizi_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/aleksandr_pushkin._kapitan_qizi_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 24,
      materialName: "alvido_qurol_ernest_xemenguej",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/alvido_qurol_ernest_xemenguej.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 25,
      materialName: "asqad_muxtor_chinor_romani",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/asqad_muxtor_chinor_romani_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 26,
      materialName: "axmad_azam_hali_hayot_bor_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/axmad_azam_hali_hayot_bor_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 27,
      materialName: "ayyor_quyoncha_haqida_ertak",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/ayyor_quyoncha_haqida_ertak.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 28,
      materialName: "besh_bolali_yigitcha",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/besh_bolali_yigitcha.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 29,
      materialName: "burgutlar",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/burgutlar.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 30,
      materialName: "erkin_azam_suv_yoqalab",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/erkin_azam_suv_yoqalab.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 31,
      materialName: "erkin_va_farovon_demokratik_ozbekiston_davlatini_birgalikda_barpo_etamiz",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/erkin_va_farovon_demokratik_ozbekiston_davlatini_birgalikda_barpo_etamiz.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 32,
      materialName: "erkin_voxidov_soz_latofati_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/erkin_voxidov_soz_latofati_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 33,
      materialName: "gabriel_garsia_markes_yolgizlikning_yuz_jili_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/gabriel_garsia_markes_yolgizlikning_yuz_jili_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 34,
      materialName: "iqrornoma_lev_tolstoj",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/iqrornoma_lev_tolstoj.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 35,
      materialName: "kapitan_qizi_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/kapitan_qizi_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 36,
      materialName: "karvon_yollari",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/karvon_yollari.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 37,
      materialName: "kuntugmish",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/kuntugmish.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 38,
      materialName: "layli_va_majnun",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/layli_va_majnun.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 39,
      materialName: "mantiqut-tayr._farididdin_attor_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/mantiqut-tayr._farididdin_attor_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 40,
      materialName: "marsel_brion._men_kim_sohibqiron_jahongir_temur.",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/marsel_brion._men_kim_sohibqiron_jahongir_temur..pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 41,
      materialName: "mehrobdan_chayon",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/mehrobdan_chayon.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id:42,
      materialName: "mirkarim_osim_zhajxun_ustida_bulutlar",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/mirkarim_osim_zhajxun_ustida_bulutlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:43,
      materialName: "mirmuhsin_xozhand_qalsi",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/mirmuhsin_xozhand_qalsi_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:44,
      materialName: "mixail_lermantov_zamonamiz_qahramoni_",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/mixail_lermantov_zamonamiz_qahramoni_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:45,
      materialName: "muxammad_ali_sarbadorlar",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/muxammad_ali_sarbadorlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:46,
      materialName: "muxammad_ali_sarbadorlar",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/muxammad_ali_sarbadorlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:47,
      materialName: "odil_yoqubov_ulugbek_hazinasi.",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/odil_yoqubov_ulugbek_hazinasi..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:48,
      materialName: "onta_negr_bolasi.",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/onta_negr_bolasi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:49,
      materialName: "orzularingiz_ogirlanishiga_jol_qojmang",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/orzularingiz_ogirlanishiga_jol_qojmang..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:50,
      materialName: "otkir_hoshimov_tushda_kechgan_umirlar",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/otkir_hoshimov_tushda_kechgan_umirlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:51,
      materialName: "pirimqul_qodirov_humoyun_va_akbar",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/pirimqul_qodirov_humoyun_va_akbar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:52,
      materialName: "pirimqul_qodirov_humoyun_va_akbar",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/pirimqul_qodirov_humoyun_va_akbar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:53,
      materialName: "qaldirgochlar_qoshigi",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/qaldirgochlar_qoshigi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:54,
      materialName: "qonun_ustuvorligi_va_inson_manfaatlarini_taminlash",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/qonun_ustuvorligi_va_inson_manfaatlarini_taminlash__yurt_taraqqiyoti_va_xalq_farovonligining_garovi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:55,
      materialName: "sariq_devni_minib",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/sariq_devni_minib.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:56,
      materialName: "shajtanat",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/shajtanat.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:57,
      materialName: "shovqin_erkin_azam_",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/shovqin_erkin_azam_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:58,
      materialName: "tanqidiy_tahlil_qatiy_tartib-intizom_va_shaxsiy_javobgarlik",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/tanqidiy_tahlil_qatiy_tartib-intizom_va_shaxsiy_javobgarlik__har_bir_rahbar_faoliyatining_kundalik_qoidasi_bolishi_kerak.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:59,
      materialName: "usmon_azim._sajlanma_",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/usmon_azim._sajlanma_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:60,
      materialName: "xurshid_davron_bibixoni_qissasi.",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/xurshid_davron_bibixoni_qissasi..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:61,
      materialName: "xurshid_davron_bibixoni_qissasi.",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/xurshid_davron_bibixoni_qissasi..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:62,
      materialName: "yodgor",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/yodgor.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:63,
      materialName: "yulduzli_tunlar",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/yulduzli_tunlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:64,
      materialName: "zaxarli_hayot_yohud_ishq__qurbonlari.",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/zaxarli_hayot_yohud_ishq__qurbonlari..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:65,
      materialName: "zhek_london_martin_iden",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/zhek_london_martin_iden.pdf",
      roll: ['student'],
      categories: ['student']
    },

  ]
  return (
    <div className='header' style={{ display: "flex", justifyContent: "center", margin: "40px auto" }}>
      <h1>Mening Malumotlarim!</h1>
      <div className='header__render'>
        <Link to="#" className='card'>
          <img className='card__img' src={image4} alt="" />
          <h2>{baza.length}</h2>
          <h4>1-2-3-4 kurs materiallari</h4>
        </Link>
        <Link to="#" className='card'>
          <img className='card__img' src={image3} alt="" />
          <h2>{elektron.length}</h2>
          <h4>Raqamli arxiv</h4>
        </Link>
        <Link to="#" className='card'>
          <img className='card__img' src={image5} alt="" />
          <h2>{pragramma.length}</h2>
          <h4>Dasturiy ta'minot</h4>
        </Link>
      </div>
      <div>
        <h2>Bazadagi barcha malumotlarimiz !</h2>
      </div>
      <div style={{ height: 400, width: '100%' }}>
        <DataGrid className='baza' style={{ width: "80%", display: "flex", justifyContent: "center", margin: "0 auto", fontFamily: "sans-serif", fontSize: "18px", scrollbarColor: "red" }}
          rows={rows}
          columns={columns}
          pageSize={31}
          rowsPerPageOptions={[31]}
          checkboxSelection
        />
      </div>
      <h2 style={{marginTop:"20px"}}>Foydalanish reytinge!</h2>
      <Statika/>

    </div>
  );
}

export default Desktop;
